exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.red-color[data-v-1b2d6718] {\n    color: red;\n    font-weight: bold;\n}\n", ""]);

// exports
